import React, {useEffect, useState} from 'react';
import {Box, Container, makeStyles, Typography} from '@material-ui/core';
import usePage from '@/hooks/usePage.js';
import Request from '@/helpers/request.js';
import mainStyles from '@/assets/js/mainStyles.js';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import ReactPlayer from "react-player";

const useStyles = makeStyles(mainStyles);

const Implementation = () => {
  const classes = useStyles();
  const [regulation, setRegulation] = useState(null);
  const { setTitle } = usePage();

  useEffect(async () => {
    const fetchModule = async () => {
      const response = (await Request.get(`/p3d2-regulation`)).items[0];
      setRegulation(response);
      setTitle('Mise en œuvre');
    };
    await fetchModule();
  }, []);

  return (
    <Container maxWidth="md">
      <Box className={classes.descRoot}>
        {regulation && (
          <div>
            <Box className={classes.videoBox} style={{ height: '500px', marginTop: 120 }}>
              <Typography variant="h5" className={classes.description}>vidéo dépliage</Typography>
              <ReactPlayer url={regulation?.unfolding} width="100%" height="100%" controls />
            </Box>
            <Box className={classes.videoBox} style={{ height: '500px', marginTop: 120, marginBottom: 120  }}>
              <Typography variant="h5" className={classes.description}>vidéo mise au mur</Typography>
              <ReactPlayer url={regulation?.wallMounted} width="100%" height="100%" controls />
            </Box>
            <Box className={classes.videoBox} style={{ height: '500px' }}>
              <Typography variant="h5" className={classes.description}>vidéo pliage</Typography>
              <ReactPlayer url={regulation?.folding} width="100%" height="100%" controls />
            </Box>
          </div>
        )}
      </Box>
    </Container>
  );
};

export default Implementation;
